/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { ComponentChildren } from 'preact';
import { rowAxisLayoutStyles } from './themes/GanttStyles.css';
import { TrackResizeContainer } from '../PRIVATE_TrackResizeContainer';

type Props = {
  rowAxisTopGap?: string;
  rowAxisBottomGap?: string;
  resolvedRowAxisWidth: { value: number; suffix?: 'px' | '%' };
  resolvedRowAxisMaxWidth: { value: number; suffix?: 'px' | '%' };
  rowAxis: (resolvedWidth: number, resolvedMaxWidth: number) => ComponentChildren;
  ganttView: ComponentChildren;
};

export function GanttWithRowAxisLayout({
  rowAxisTopGap = '0',
  rowAxisBottomGap = '0',
  resolvedRowAxisWidth,
  resolvedRowAxisMaxWidth,
  rowAxis,
  ganttView
}: Props) {
  const isRelativeWidth = resolvedRowAxisWidth.suffix === '%';
  const isRelativeMaxWidth = resolvedRowAxisMaxWidth.suffix === '%';
  return isRelativeWidth || isRelativeMaxWidth ? (
    <TrackResizeContainer width="100%" height="100%">
      {(width, _) => (
        <div
          class={rowAxisLayoutStyles.base}
          style={{ gridTemplateRows: `${rowAxisTopGap} minmax(0, 1fr) ${rowAxisBottomGap}` }}>
          <div class={rowAxisLayoutStyles.rowAxis}>
            {rowAxis(
              isRelativeWidth
                ? width * (resolvedRowAxisWidth.value / 100)
                : resolvedRowAxisWidth.value,
              isRelativeMaxWidth
                ? width * (resolvedRowAxisMaxWidth.value / 100)
                : resolvedRowAxisMaxWidth.value
            )}
          </div>
          <div class={rowAxisLayoutStyles.ganttView}>{ganttView}</div>
        </div>
      )}
    </TrackResizeContainer>
  ) : (
    <div
      class={rowAxisLayoutStyles.base}
      style={{ gridTemplateRows: `${rowAxisTopGap} minmax(0, 1fr) ${rowAxisBottomGap}` }}>
      <div class={rowAxisLayoutStyles.rowAxis}>
        {rowAxis(resolvedRowAxisWidth.value, resolvedRowAxisMaxWidth.value)}
      </div>
      <div class={rowAxisLayoutStyles.ganttView}>{ganttView}</div>
    </div>
  );
}
